import React from "react";
import { Link } from "react-router-dom";
import "./QuestPreview.css";

const QuestPreview = ({
  quests,
  title = "Quests",
  showDiscoverAll = false,
}) => (
  <section className="quest-preview">
    <h2 style={{ textAlign: "center" }}>{title}</h2>
    <div className="quest-list">
      {quests && quests.length > 0 ? (
        quests.map((quest) => (
          <Link to={`/projects/${quest.slug}`} key={quest.slug} className="quest-card-link">
            <div className="quest-card">
              {quest.image && (
                <div className="quest-card-image">
                  <img src={process.env.PUBLIC_URL + quest.image} alt={quest.title} />
                </div>
              )}
              <div className="quest-card-content">
                <h3>{quest.title}</h3>
                <div className="quest-meta">
                  <span className="quest-date">{quest.date}</span>
                  {quest.status && (
                    <span className={`quest-status quest-status-${quest.status}`}>
                      {quest.status === "completed" ? "Completed" :
                       quest.status === "in-progress" ? "In Progress" : "Planned"}
                    </span>
                  )}
                </div>
                {quest.tags && quest.tags.length > 0 && (
                  <div className="quest-tags">
                    {quest.tags.map((tag) => (
                      <span key={tag} className="quest-tag">{tag}</span>
                    ))}
                  </div>
                )}
                <p className="quest-excerpt">{quest.excerpt}</p>
                <span className="quest-readmore">
                  View quest details →
                </span>
              </div>
            </div>
          </Link>
        ))
      ) : (
        <p>No quests discovered yet.</p>
      )}
    </div>
    {showDiscoverAll && (
      <div style={{ textAlign: "left", marginTop: "1.5rem" }}>
        <Link to="/projects" className="discover-quests-link">
          View all quests
        </Link>
      </div>
    )}
  </section>
);

export default QuestPreview;
